import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Params, RouterModule } from '@angular/router';
import { AccountService } from '@jfw/angular/shared/services';
import { ModuleAccessEnum } from '@jfw/types';
import { AuthService } from '../../services/auth/auth.service';

@Component({
  selector: 'app-module-header',
  templateUrl: './module-header.component.html',
  styleUrl: './module-header.component.scss',
  imports: [
    RouterModule,
    MatTabsModule,
    MatIconModule,
    MatTooltipModule,
    MatMenuModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModuleHeaderComponent {
  private readonly authService = inject(AuthService);
  private readonly accountService = inject(AccountService);
  private readonly platformAccount = this.accountService._platformAccount;

  protected readonly currentSuite = toSignal(this.authService.currentSuite$);

  protected readonly currentModule = toSignal(this.authService.currentModule$);

  protected readonly mainModules = computed(
    () =>
      this.currentSuite()?.modules.filter(
        (module) => !module.data.groupInSuiteMoreMenu,
      ) ?? [],
  );

  protected readonly moreModules = computed(
    () =>
      this.currentSuite()?.modules.filter(
        (module) => module.data.groupInSuiteMoreMenu,
      ) ?? [],
  );

  protected readonly isMoreModuleActive = computed(() =>
    this.moreModules().some(
      (module) => module.data.enumeration === this.currentModule()?.enumeration,
    ),
  );

  // EXT-6537: More… › Phone/Account Associations opens the loaded account's
  // numbers, the same as the Dashboard's associations button.
  protected moreMenuQueryParams(
    module: ModuleAccessEnum | undefined,
  ): Params | null {
    const accountNumber = this.platformAccount()?.accountNumber;
    return module === ModuleAccessEnum.IncomingCallAssociation && accountNumber
      ? { account: accountNumber }
      : null;
  }
}
